import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles({
  reactSelect: {
    border: "none",
    marginLeft: 10,
  },
  navButton: {
    padding: 8,
  }
});

export default useStyles;
